module.exports = __webpack_public_path__ + "img/CheckinManual.86a89183.png";